(() => {
 'use strict';
 const main=document.querySelector('#MainContent');if(!main)return;
 function shorten(el,handle){
  if(el.dataset.dhShort)return;
  const title=el.textContent.trim(),short=window.dollopCardTitle({handle,title});
  el.dataset.dhShort='true';
  if(short!==title){el.title=title;el.textContent=short}
 }
 function refresh(){
  ensureOptions();
  const handle=location.pathname.split('/products/')[1]?.split('/')[0];
  if(handle){main.querySelectorAll('.product-details h1').forEach(e=>shorten(e,handle));document.querySelectorAll('.sticky-add-to-cart__title').forEach(e=>shorten(e,handle))}
  main.querySelectorAll('product-card').forEach(card=>{
   const href=card.querySelector('a[href*="/products/"]')?.getAttribute('href');if(!href)return;
   const h=href.split('/products/')[1]?.split('?')[0];
   card.querySelectorAll('[role="heading"],h3.product-grid-view-zoom-out--details').forEach(e=>shorten(e,h));
  });
  if(main.dataset.dhTemplate==='collection'){const h=main.querySelector('h1'),active=main.querySelector('.dh-catalogue-nav [aria-current="page"]');if(h&&active&&h.textContent!==active.textContent)h.textContent=active.textContent}
 }
 refresh();let queued=false;
 new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;refresh()})}).observe(main,{childList:true,subtree:true});
 // Keep Shopify's original variant, quantity and purchase handlers intact.
 function ensureOptions(){
 const bar=document.querySelector('.sticky-add-to-cart__bar');
 if(bar&&!bar.querySelector('.dh-review-options')){
  const options=document.createElement('button');options.type='button';options.className='dh-review-options';options.textContent=document.querySelector('.product-details variant-picker')?'Choose options':'Change quantity';
  options.addEventListener('click',()=>{const target=[...document.querySelectorAll('.product-details variant-picker select,.product-details .dl-base-choice input,.product-details product-form-component input[name="quantity"]')].find(e=>e.getClientRects().length);target?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});target?.focus({preventScroll:true})});
  bar.append(options);
 }
 }
})();
